import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { logout } from './AuthSlice'
const apiURL = process.env.REACT_APP_BACKEND

const initialState = {
  companies: [],
  companyCount: 0,
}

export const getCompanies = createAsyncThunk('company/getCompanies', async (props, thunkAPI) => {
  // access the entire redux state
  const state = thunkAPI.getState()
  const { authId, webToken, subscriberId, customerId } = state.auth
  const filters = props?.filters

  let reqBody = filters ? {...filters} : {}
  if (authId === 1) {
    reqBody.subscriberId = subscriberId
  } else if (authId !== 100) {
    reqBody.customerId = customerId
  }

  return await fetch(apiURL + 'api/gatecompaniesNew', {
    method: 'POST',
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': webToken
    },
    credentials: 'include',
    body: JSON.stringify(reqBody),
  })
  .then(response => response.json())
  .then(data => {
    data.pageIndex = filters && filters.page ? filters.page : 1
    return data
  })
  .catch(error => {
      console.error('Error:', error);
      // no count on the payload signals a failed fetch to the caller (which then
      // keeps the currently-shown list instead of clearing it).
      return {rows: [], pages: 0, pageIndex: filters && filters.page ? filters.page : 1}
  })
});

const companySlice = createSlice({
  name: 'company',
  initialState,
  reducers: {
    setCompanyState: (state, action) => {
      state[action.payload.field] = action.payload.value
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCompanies.fulfilled, (state, action) => {
        // Store holds only the latest page (used by the Lpn/Person company
        // dropdown when fetched unpaginated). Infinite-scroll accumulation lives
        // in CataloguePane's own state, not here, so localStorage isn't bloated.
        state.companies = action.payload.rows
        if (action.payload.count !== undefined) state.companyCount = action.payload.count
      })
      .addCase(logout, (state, action) => {
        return { ...initialState }
      })
  },
})

export const { setCompanyState } = companySlice.actions
export default companySlice.reducer
